import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var ArrowBack = function ArrowBack(props) {
  useDeprecatedComponentWarning({
    component: 'ArrowBack'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M427 235v42H167l119 120-30 30L85 256 256 85l30 30-119 120h260z"
  }));
};

ArrowBack.displayName = 'ArrowBack';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ArrowBack.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default ArrowBack;